import React from 'react'
import { congregationOptions } from 'constants/congregationOptions'
import { createColumn } from '../../../../utils/tableColumnHelpers'

export const makeCalculationsRowsCongregationCriteria = (congregationList) => {
  return congregationList.map((item) => {
    const speciesGroup = congregationOptions.find((element) => {
      return element.value === item.CongregationGroupId
    })

    return {
      speciesGroup: speciesGroup.label,
      estimateBest: item.best === null ? '-' : item.best,
      ibaCriteria: item.congregationCriterias.length > 0 ? item.congregationCriterias.join(', ') : '-'
    }
  })
}



export const makeCalculationsColumnsCongregationCriteria = (canSeeIBACriteria) => {
  const baseColumns = [
    createColumn({
      id: 'speciesGroup',
      headerId: 'speciesGroup',
      accessorKey: 'speciesGroup'
    }),
    createColumn({
      id: 'estimateBest',
      headerId: 'estimateBest',
      accessorKey: 'estimateBest'
    })
  ]

  // Only add IBA criteria column if user has IBA access
  if (canSeeIBACriteria) {
    baseColumns.push(createColumn({
      id: 'ibaCriteria',
      headerId: 'ibaCriteria',
      accessorKey: 'ibaCriteria'
    }))
  }

  return baseColumns
}
